"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transparentize = exports.mix = exports.idealTextColorAgainstWhite = exports.idealTextColor = exports.getIdealTextColor = exports.getIdealColors = exports.getColorRange = exports.darken = void 0;
var _memoize = _interopRequireDefault(require("lodash/memoize"));
var _Pixel;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Pixel = /*#__PURE__*/function () {
  function Pixel() {
    _classCallCheck(this, Pixel);
    var canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    this.ctx = canvas.getContext('2d');
  }
  return _createClass(Pixel, [{
    key: "clear",
    value: function clear() {
      this.ctx.clearRect(0, 0, 1, 1);
    }
  }, {
    key: "fill",
    value: function fill(color) {
      this.ctx.fillStyle = color;
      this.ctx.fillRect(0, 0, 1, 1);
    }
  }, {
    key: "components",
    get: function get() {
      // NB. IE11 is unable to deconstruct an ImageData
      // object, so we're doing it manually

      var _this$ctx$getImageDat = this.ctx.getImageData(0, 0, 1, 1),
        data = _this$ctx$getImageDat.data;
      return {
        r: data[0],
        g: data[1],
        b: data[2],
        a: data[3] / 255
      };
    }
  }]);
}();
_Pixel = Pixel;
_defineProperty(Pixel, "decode", function (color) {
  var pixel = _Pixel.getInstance();
  pixel.clear();
  pixel.fill(color);
  return pixel.components;
});
_defineProperty(Pixel, "encode", function (_ref) {
  var r = _ref.r,
    g = _ref.g,
    b = _ref.b,
    a = _ref.a;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
});
_defineProperty(Pixel, "getInstance", (0, _memoize["default"])(function () {
  return new _Pixel();
}));
var idealTextColor = exports.idealTextColor = function idealTextColor(bgColor) {
  var nThreshold = 105;
  var components = Pixel.decode(bgColor);
  var bgDelta = components.r * 0.299 + components.g * 0.587 + components.b * 0.114;
  return 255 - bgDelta < nThreshold ? '#000000' : '#ffffff';
};
var idealTextColorAgainstWhite = exports.idealTextColorAgainstWhite = function idealTextColorAgainstWhite(bgColor) {
  var nThreshold = 105;
  var components = Pixel.decode(bgColor);
  var bgDelta = components.r * 0.299 + components.g * 0.587 + components.b * 0.114;
  return 255 - bgDelta < nThreshold ? '#000000' : bgColor;
};
var getIdealColors = exports.getIdealColors = function getIdealColors(color) {
  return {
    backgroundColor: color,
    color: idealTextColor(color)
  };
};
var getIdealTextColor = exports.getIdealTextColor = function getIdealTextColor(color) {
  return {
    color: idealTextColor(color)
  };
};
var getColorRange = exports.getColorRange = function getColorRange() {
  var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var getColor = function getColor(value) {
    var hue = ((1 - value) * 120).toString(10);
    return ['hsl(', hue, ',100%,45%)'].join('');
  };
  var range = [];
  for (var i = 0; i <= steps - 1; i++) {
    range.push(getColor(i / (steps - 1)));
  }
  return range.reverse();
};
var darken = exports.darken = function darken(color, amount) {
  var pixel = Pixel.getInstance();
  pixel.clear();
  pixel.fill(color);
  pixel.fill(Pixel.encode({
    r: 0,
    g: 0,
    b: 0,
    a: amount
  }));
  return Pixel.encode(pixel.components);
};
var mix = exports.mix = function mix(color1, color2, amount) {
  var pixel = Pixel.getInstance();
  var overlay = transparentize(color2, amount);
  pixel.clear();
  pixel.fill(color1);
  pixel.fill(overlay);
  return Pixel.encode(pixel.components);
};
var transparentize = exports.transparentize = function transparentize(color, amount) {
  var _Pixel$decode = Pixel.decode(color),
    r = _Pixel$decode.r,
    g = _Pixel$decode.g,
    b = _Pixel$decode.b,
    a = _Pixel$decode.a;
  return Pixel.encode({
    r: r,
    g: g,
    b: b,
    a: amount * a
  });
};
//# sourceMappingURL=color-utils.js.map